import { useState } from "react";
import { CollapsibleSection } from "../CollapsibleSection";
import { Button } from "@/components/ui/button";
import { Volume } from "lucide-react";

interface DevotionalMessageProps {
  message: string;
  id?: string;
}

export const DevotionalMessage = ({ message, id }: DevotionalMessageProps) => {
  const [isReading, setIsReading] = useState(false);

  const handleTextToSpeech = () => {
    if (!isReading) {
      const utterance = new SpeechSynthesisUtterance(message);
      window.speechSynthesis.speak(utterance);
      setIsReading(true);
      utterance.onend = () => setIsReading(false);
    } else {
      window.speechSynthesis.cancel();
      setIsReading(false);
    }
  };

  return (
    <CollapsibleSection title="Message" id={id}>
      <div className="relative">
        <Button
          variant="ghost"
          size="icon"
          onClick={handleTextToSpeech}
          className="absolute top-0 right-0 hover:bg-sage-100"
        >
          <Volume className={isReading ? "text-sage-500" : ""} />
        </Button>
        <div className="leading-relaxed text-lg whitespace-pre-line pr-12 text-center text-justify font-serif">
          {message.split('|').map((paragraph, index) => (
            <p key={index} className="mb-4">
              {paragraph.trim()}
            </p>
          ))}
        </div>
      </div>
    </CollapsibleSection>
  );
};